import { Injectable } from "@angular/core";
import { patchState, signalStore, withState } from "@ngrx/signals";
import { RouteBreadcrumbService } from "../services/route-breadcrumb.service";

export type Breadcrumb = {
  label: string;
  url: string;
};

export type BreadcrumbState = {
  breadcrumbs: Breadcrumb[];
};

const initialState: BreadcrumbState = {
  breadcrumbs: [],
};

@Injectable({ providedIn: "root" })
export class RouteBreadcrumbStore extends signalStore({ protectedState: false }, withState(initialState)) {
  constructor(private readonly routeBreadcrumbService: RouteBreadcrumbService) {
    super();
  }

  initialize(): void {
    this.routeBreadcrumbService.initialize();
    this.routeBreadcrumbService.breadcrumbs$.subscribe((breadcrumbs: Breadcrumb[]) => {
      patchState(this, { breadcrumbs });
    });
  }
}
